import Vue from 'vue'
import masterApiCall from '@/masteradmin/utils/api'
import { Notification } from 'element-ui'

import {
  ACTION_GET_COURSES,
} from '../actions'

import {
  MUTATION_SET_COURSES,
} from '../mutations'


const coursesModule = {
  state: {
    courses: [],
    itemTotal: 0,
    pageSize: 0,
    loading: false,
    domain: '',
  },

  mutations: {
    [MUTATION_SET_COURSES](state, data) {
      const {
        courses, domain, itemTotal, pageSize,
      } = data
      const list = courses.map((course) => {
        const { application, studentsMetric, ...courseData } = course
        return {
          ...courseData,
          url: `https://${course.code}.${domain}`,
          instructor: application ? `${application.user.firstName} ${application.user.lastName}` : null,
          description: application ? application.course.description : null,
          email: application ? application.email : null,
          students: studentsMetric && studentsMetric.length > 0 ? studentsMetric[0].value : 0,
        }
      })
      Vue.set(state, 'courses', list)
      Vue.set(state, 'itemTotal', itemTotal)
      Vue.set(state, 'pageSize', pageSize)
      Vue.set(state, 'domain', domain)
    },

    setLoading(state, isLoading) {
      Vue.set(state, 'loading', isLoading)
    },
  },

  actions: {
    [ACTION_GET_COURSES]({ commit }, { page }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        masterApiCall('get', `/masteradmin/courses?page=${page}`)
          .then(({ data }) => {
            commit(MUTATION_SET_COURSES, data)
            commit('setLoading', false)
            resolve()
          }, () => {
            Notification.error({
              title: 'Error!',
              message: 'Unable to retrieve course list.',
              position: 'bottom-right',
            })
            commit('setLoading', false)
            reject()
          })
      })
    },


  },
}

export default coursesModule



// WEBPACK FOOTER //
// ./client/masteradmin/store/coursesModule/index.js